import { createFileRoute } from "@tanstack/react-router";
import { Buyers } from "../../../components/buyers/buyers";

export const Route = createFileRoute("/_app/buyers/")({
  component: Buyers
});
